// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YFGZK","messages":"styles_messages__35WTC"};